/**
 * AddModuleDialog - Dialog for creating new modules or submodules
 * Reusable for both module and submodule creation and editing
 */
import Dialog from '../../../../../organisms/dialogs/Dialog/Dialog';
import React from 'react';
import FormField from '../../../../../molecules/FormField/FormField';
import InputText from '../../../../../atoms/InputText/InputText';
import type { AddItemDialogProps } from '../../types';
import useAddModuleDialog from './useAddModuleDialog';

function AddModuleDialog({ isOpen, type, onClose, onConfirm, isLoading = false, initialName, mode = 'add' }: AddItemDialogProps): JSX.Element {
  const { t, title, label, disclaimer, name, handleNameChange, handleConfirm, handleClose, isDisabled, showError, errorMessage } = useAddModuleDialog({
    type,
    onClose,
    onConfirm,
    isLoading,
    initialName,
    mode,
  });

  return (
    <Dialog
      isOpen={isOpen}
      onClose={handleClose}
      title={title}
      size="m"
      buttonTextCancel={t('actions:Cancel')}
      buttonTextSuccess={t('actions:Save')}
      onCancel={handleClose}
      onSuccess={handleConfirm}
      isDisabledSuccess={isDisabled}
      isLoading={isLoading}
    >
      <div className="add-module-dialog">
        <div className="add-module-dialog__input">
          <FormField
            error={!!showError}
            errorMessage={errorMessage}
            isDisabled={isLoading}
            label={label}
          >
            <InputText
              placeholder={t('placeholder:Write here')}
              value={name}
              onChange={handleNameChange}
            />
          </FormField>
        </div>

        <div className="add-module-dialog__disclaimer">
          <span>{disclaimer}</span>
        </div>
      </div>
    </Dialog>
  );
}

export default AddModuleDialog;
